// extracted by mini-css-extract-plugin
export default {"groupCard":"styles_groupCard__5lmnu","details":"styles_details__i48C+","icon":"styles_icon__gA52g","img":"styles_img__ZJ8Jq"};